/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

// On-page modals:  have a <label> that points to the modal-state checkbox
//
// Remote modals:  have an <a> tag with a data-modal attr pointing to the url

App.ready(() => App.modals.init());

App.modals = {
  init() {
    // Need to make existing modals direct children of body so that the
    // background spans the full body width (seems to be a Chrome bug)
    $(".modal-wrapper").appendTo("body");
    $(document)
      .off("click", ".modal-window", App.modals.window_clicked)
      .on("click", ".modal-window", App.modals.window_clicked);

    App.modals.remote_init();
    $(document)
      .off("click", ".js-modal-close", App.modals.close)
      .on("click", ".js-modal-close", App.modals.close);

    return App.emit("modals-inited");
  },

  close(evt) {
    evt.preventDefault();
    return $(this).closest(".modal-wrapper").find(".modal-state").prop("checked", false);
  },

  close_all() {
    $(".modal-state").prop("checked", false);
    return $(".modal-window").removeAttr("active");
  },

  focus_first_field() {
    const field = $(".modal-state:checked ~ .modal-window [autofocus]");

    if (field[0] && field[0].selectize) {
      if (!field.val()) { return field[0].selectize.focus(); }
    } else {
      return field.focus();
    }
  },

  window_clicked(evt) {
    if ($(evt.target).hasClass("modal-window") && !$(evt.target).hasClass("modal-window--sticky")) {
      return App.modals.close_all();
    }
  },

  // Remote loading:
  //
  // - find all links with a data-modal attr
  remote_init() {
    return $(document)
      .off("click", "[data-modal]", App.modals.remote_clicked)
      .on("click", "[data-modal]", App.modals.remote_clicked);
  },

  //   - on click, ajax GET the href
  //     - prevent default
  remote_clicked(evt) {
    evt.preventDefault();
    const trigger = $(this);

    return App.modals.remote_request(trigger.attr("href"), trigger.attr("data-modal"));
  },

  remote_request(url, modal_id) {
    return $.get(url, (data, status, xhr) => App.modals.remote_success(modal_id, data, status, xhr));
  },

  //     - on success,
  //       - hide all other modals
  //       - look for element with value of data-modal on page
  //       - if present, remove its parent .modal-wrapper
  //       - append response to body
  //       - click the data-modal value checkbox to show modal
  remote_success(data_modal_id, data, status, xhr) {
    $(data_modal_id).closest(".modal-wrapper").remove();
    $("body").append(data);
    return App.modals.show_modal(data_modal_id);
  },

  show_modal(id) {
    App.modals.close_all();
    // Wait a few ticks so the css animations work
    return window.setTimeout(function() {
      $(id).click();
      $(document).trigger("modal:load");
      return App.modals.focus_first_field();
    }
    , 50);
  }
};
